import Cookies from 'js-cookie';
import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, CHANGE_LANG, SET_USER, SET_ALERT, SHOW_LOADING } from 'context/actions/auth';

let user;
if (process.browser) {
    user = JSON.parse(localStorage.getItem('user'));
}

let lang = 'mn';
if (typeof window !== 'undefined') {
    const chosenLang = Cookies.get('chosen_lang');
    if (chosenLang) lang = chosenLang;
}

const initialState = user ? { 
        loggedIn: true, 
        user, 
        lang: lang, 
        showLoading: false, 
        alert:{ isShow: false, type: 'success', message: '' } 
    } : { 
        lang: lang,
        showLoading: false, 
        alert:{ isShow: false, type: 'success', message: '' } 
    };

const reducer = (state, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            Cookies.set('auth_token', action.data.token, { expires: 7 });
            localStorage.setItem('user', JSON.stringify(action.data));
            return {
                ...state,
                loggedIn: true,
                user: action.data,
            };
        case LOGIN_ERROR:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { ...state, loggedIn: false, user: null };
        case LOGOUT:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { ...state, loggedIn: false, user: null };

        case CHANGE_LANG:
            return { ...state, lang: action.data };

        case SET_ALERT:
            return { ...state, alert: action.data };
        case SHOW_LOADING:
            return { ...state, showLoading: action.data };
        case SET_USER:
            localStorage.setItem('user', JSON.stringify({ ...action.data }));
            return { ...state, user: action.data };

        default:
            return state;
    }
};

const authReducer = [reducer, initialState];

export default authReducer;
